<template>
  <div>
    <Header :title="$t('changepwd.title')" />
    <div class="full-page-box">
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <van-field
            class="input"
            v-model="old_password"
            :placeholder="$t('changepwd.oldpwddesc')"
            :rules="[{ required: true }]"
          >
            <template #left-icon>
              <span class="icon-item"
                ><svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 448 512"
                  class="absolute top-1/2 -translate-y-1/2 left-2 text-primary text-lg"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                  ></path></svg              ></span>
            </template>
          </van-field>
          <van-field
            class="input"
            v-model="o_new_password"
            :placeholder="$t('changepwd.newpwddesc')"
            :rules="[{ required: true }]"
          >
            <template #left-icon>
              <span class="icon-item"
                ><svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 448 512"
                  class="absolute top-1/2 -translate-y-1/2 left-2 text-primary text-lg"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                  ></path></svg              ></span>
            </template>
          </van-field>
          <van-field
            class="input"
            v-model="t_new_password"
            :placeholder="$t('changepwd.agepwddesc')"
            :rules="[{ required: true }, { validator }]"
          >
            <template #left-icon>
              <span class="icon-item"
                ><svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 448 512"
                  class="absolute top-1/2 -translate-y-1/2 left-2 text-primary text-lg"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                  ></path></svg              ></span>
            </template>
          </van-field>
          <div style="margin-top: 16px">
            <van-button class="btn" native-type="submit">{{
              $t("changepwd.btn")
            }}</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/index.vue";
import { Toast } from "vant";
export default {
  name: "ChangePwd",
  components: { Header },
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
    };
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    }
  },
  methods: {
    validator(val) {
      return this.o_new_password == val;
    },
    onSubmit() {
      this.$http({
        method: "get",
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: "user_set_loginpw",
      }).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("login");
          }, 500);
        } else {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.frm-box {
  width: 94%;
  margin: 10px auto;
  padding: 10px;
}
.frm-box .icon-item {
  color: rgb(4 109 181);
  font-size: 18px;
}
.frm-box .input {
  border: 1px solid rgb(4 109 181) !important;
  border-radius: 8px;
  margin-bottom: 15px;
}
.frm-box .btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181) !important;
  border-radius: 8px;
  color: #fff;
  width: 100%;
}
</style>
